<template>
  <LegalPage title="Return &amp; Refund Policy" last-updated="August 30, 2025">
    <p>
      At Nilkhet Books, every book is printed on order especially for you. For
      this reason, our return and refund terms are different from those of a
      typical retailer. Please read this policy carefully before placing your
      order.
    </p>

    <h2>1. Books Are Printed on Order</h2>
    <p>
      Because each book is printed specifically for your order, we are unable to
      accept returns or offer refunds for reasons such as change of mind,
      ordering the wrong title, or no longer wanting the book. We therefore
      encourage you to review your order details carefully before confirming your
      purchase.
    </p>

    <h2>2. Free Replacement for Printing Defects</h2>
    <p>
      We stand fully behind the quality of every book we produce. If your book
      arrives with a printing defect, we will replace it free of charge.
    </p>
    <div class="highlight-box">
      <p>
        If you find any <strong>missing pages</strong> or a
        <strong>misprint</strong> in your book, we will provide you with a fresh
        copy at <strong>no additional charge</strong> and collect the faulty copy
        from you.
      </p>
    </div>
    <p>Qualifying defects include:</p>
    <ul>
      <li>Missing, blank, or duplicated pages.</li>
      <li>Misprinted, smudged, or illegible text.</li>
      <li>Pages bound out of order.</li>
      <li>Significant printing or binding faults that affect readability.</li>
    </ul>

    <h2>3. How to Request a Replacement</h2>
    <p>
      To request a free replacement for a defective book, please contact us
      within <strong>7 days</strong> of receiving your order:
    </p>
    <ol>
      <li>
        Reach out to us by phone, email, or through our
        <router-link to="/contact">Contact page</router-link>.
      </li>
      <li>
        Share your order number and a brief description of the defect. Photos of
        the missing pages or misprint help us process your request faster.
      </li>
      <li>
        Once verified, we will arrange delivery of a fresh copy and collect the
        faulty copy from you.
      </li>
    </ol>

    <h2>4. Damage in Transit</h2>
    <p>
      If your book arrives physically damaged due to delivery handling, please
      contact us within 48 hours of receiving it, with photos of the damage and
      the packaging. We will arrange a replacement in the same way as for
      printing defects.
    </p>

    <h2>5. What Is Not Covered</h2>
    <ul>
      <li>Change of mind or ordering the wrong title.</li>
      <li>Minor cover finish, colour, or binding variations between print runs.</li>
      <li>Damage caused after delivery through normal wear or misuse.</li>
      <li>Requests made after the time windows described above.</li>
    </ul>

    <h2>6. Refunds</h2>
    <p>
      As our books are printed on order, we generally do not offer cash refunds.
      In the rare event that we are unable to provide a replacement for a
      confirmed defect, we will discuss a suitable resolution with you, which may
      include a refund of the amount paid for the affected book.
    </p>

    <h2>7. Order Cancellation</h2>
    <p>
      Because printing begins soon after your order is confirmed, cancellations
      may only be possible if printing has not yet started. Please contact us as
      soon as possible if you wish to cancel an order.
    </p>

    <h2>8. Contact Us</h2>
    <div class="highlight-box">
      <p>
        <strong>Nilkhet Books</strong><br />
        Shop 146, 1st Floor, Gausul Azam Super Market, Nilkhet, Dhaka 1205<br />
        Phone: <a href="tel:+8801711086468">+880 1711 086 468</a><br />
        Email:
        <a href="mailto:nilkhetdotcom@gmail.com">nilkhetdotcom@gmail.com</a>
      </p>
    </div>
  </LegalPage>
</template>

<script>
import LegalPage from "@/components/LegalPage.vue";

export default {
  name: "ReturnRefundPolicy",
  components: { LegalPage },
};
</script>
